import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Autocomplete } from '@amtrav/view-components';

// forwardRef is needed to that we can access the native input from TextInput
const JumpToInput = forwardRef(({ withFocus, ...props }, ref) => {
  return <Autocomplete.Input ref={ref} withFocus={withFocus} prefixContent={withFocus ? <></> : null} {...props} />;
});

JumpToInput.propTypes = {
  withFocus: PropTypes.bool.isRequired,
};

export default JumpToInput;
